import React from "react";

const AccessIcon = ({ fill = "#387CFF", stroke = "#387CFF", ...props }) => (
  <svg
    width="19"
    height="19"
    viewBox="0 0 18 18"
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    {...props} // Spread additional props (e.g., className, style)
  >
    <path
      d="M11.7596 10.9402C14.3771 10.9402 16.4996 8.82675 16.4996 6.21975C16.4996 3.61275 14.3771 1.5 11.7596 1.5C9.14208 1.5 7.02183 3.6135 7.02183 6.21975C7.02183 7.42725 7.57233 8.3055 7.57233 8.3055L1.84083 14.013C1.58358 14.2695 1.22358 14.9355 1.84083 15.5505L2.50233 16.209C2.75958 16.4287 3.40608 16.7362 3.93483 16.209L4.70733 15.441C5.47833 16.209 6.36033 15.7703 6.69108 15.3307C7.24158 14.5627 6.58083 13.794 6.58083 13.794L6.80133 13.5743C7.85883 14.6288 8.78508 14.0138 9.11583 13.5743C9.66708 12.8063 9.11583 12.0375 9.11583 12.0375C8.89533 11.5987 8.45433 11.5987 9.00558 11.0497L9.66708 10.3912C10.1958 10.83 11.2833 10.9402 11.7611 10.9402H11.7596Z"
      stroke={stroke}
      strokeLinejoin="round"
    />
    <path
      d="M13.4134 6.22049C13.4124 6.65797 13.2377 7.07714 12.9277 7.38585C12.6177 7.69456 12.1978 7.86754 11.7604 7.86674C11.3229 7.86754 10.903 7.69456 10.593 7.38585C10.283 7.07714 10.1084 6.65797 10.1074 6.22049C10.1078 6.00381 10.1508 5.78933 10.2341 5.58929C10.3174 5.38925 10.4393 5.20758 10.5928 5.05464C10.7463 4.9017 10.9284 4.7805 11.1287 4.69794C11.329 4.61538 11.5437 4.57309 11.7604 4.57349C11.977 4.57309 12.1917 4.61538 12.392 4.69794C12.5924 4.7805 12.7745 4.9017 12.928 5.05464C13.0815 5.20758 13.2033 5.38925 13.2866 5.58929C13.3699 5.78933 13.413 6.00381 13.4134 6.22049Z"
      stroke={stroke}
    />
  </svg>
);

export default AccessIcon;
